import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccSettings, shopHttp } from '../basket-api';

export const deleteBasket = async (basketId: string): Promise<void> => {
  const url = `/baskets/${basketId}`;
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);

  const response = await shopHttp.delete<void>(finalUrl);

  return response.data;
};
